import { render, staticRenderFns } from "./OrderConfirmDialogPoint.vue?vue&type=template&id=0be6eb82&scoped=true"
import script from "./OrderConfirmDialogPoint.vue?vue&type=script&lang=ts"
export * from "./OrderConfirmDialogPoint.vue?vue&type=script&lang=ts"
import style0 from "./OrderConfirmDialogPoint.vue?vue&type=style&index=0&id=0be6eb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6eb82",
  null
  
)

export default component.exports